import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchRolesListAPI(filters) {
    return await  axiosClient.get(`/api/v1/admin/get?${getQueryString(filters)}`);
}

export async function fetchRoleDetailsAPI(roleId) {
    return await axiosClient.get(`/api/v1/admin/${roleId}`);
}

export async function addRoleAPI(data) {
    return await  axiosClient.post(`/api/v1/admin/create`, data);
}

export async function updateRoleAPI(data, roleId) {
    return await  axiosClient.put(`/api/v1/admin/edit/${roleId}`, data);
}

export async function deleteRoleAPI(roleId) {
    return await axiosClient.delete(`/api/v1/admin/role/permissions/roles/${roleId}`);
}
export async function deleteUserAPI(roleId) {
    return await axiosClient.delete(`/api/v1/admin/delete/${roleId}`);
}

export async function fetchRoleAndPermissionsListAPI(filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/roles/permission?${getQueryString(filters)}`);
}

export async function addRoleandPermissionAPI(data,roleId) {
    if(roleId){
        return await axiosClient.put(`/api/v1/admin/role/permissions/roles/${roleId}`, data);
    }else{
        return await axiosClient.post(`/api/v1/admin/role/permissions/roles`, data);
    }
}


export async function getRoleandPermissionApi(data) {
    return await axiosClient.get(`/api/v1/admin/role/permissions/listing/all`);
}


export async function getRoleandPermissionByIDApi(data) {
    return await axiosClient.get(`/api/v1/admin/role/permissions/roles/${data}`);
}

export async function deleteBulkRoleApi(data) {
   
    return await axiosClient.post(`/api/v1/admin/bulk/delete`,data);
}